import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Globe,
  ArrowUpRight,
} from "lucide-react";

import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="nf-footer">

      {/* Background */}
      <div className="nf-footer-grid"></div>

      <div className="nf-footer-glow nf-footer-glow-left"></div>

      <div className="nf-footer-glow nf-footer-glow-right"></div>


      {/* =====================================================
          FOOTER MAIN
      ====================================================== */}

      <div className="nf-footer-main">

        <div className="nf-footer-container">


          {/* =================================================
              BRAND
          ================================================== */}

          <div className="nf-footer-brand">

            <Link
              to="/overview"
              className="nf-footer-logo"
            >

              <span className="nf-footer-logo-box">
                N
              </span>

              <span className="nf-footer-logo-text">
                NEXIS<span>FOLD</span>
              </span>

            </Link>


            <p className="nf-footer-brand-description">

              Nexis Fold is a software development company
              focused on building modern websites, scalable
              software applications, AI solutions and
              intelligent automation systems.

            </p>


            <div className="nf-footer-status">

              <span className="nf-status-pulse"></span>

              <span>
                Available for new projects
              </span>

            </div>

          </div>



          {/* =================================================
              COMPANY
          ================================================== */}

          <div className="nf-footer-column">

            <h3>
              COMPANY
            </h3>


            <Link to="/overview">
              Overview
            </Link>

            <Link to="/about">
              About Us
            </Link>

            <Link to="/projects">
              Projects
            </Link>

            <Link to="/process">
              Our Process
            </Link>

            <Link to="/contact">
              Contact
            </Link>

          </div>



          {/* =================================================
              SERVICES
          ================================================== */}

          <div className="nf-footer-column">

            <h3>
              SERVICES
            </h3>


            <Link to="/services">
              Web Development
            </Link>

            <Link to="/services/mobile-app-development">
              Mobile App Development
            </Link>

            <Link to="/services/ai-machine-learning">
              AI & Machine Learning
            </Link>

            <Link to="/services/ai-automation">
              AI Automation
            </Link>

            <Link to="/services/custom-software">
              Custom Software
            </Link>

          </div>



          {/* =================================================
              CONTACT
          ================================================== */}

          <div className="nf-footer-column nf-footer-contact">

            <h3>
              GET IN TOUCH
            </h3>


            <a
              href="mailto:nexisfold@gmail.com"
              className="nf-footer-contact-item"
            >

              <span className="nf-contact-icon">
                <Mail size={18} />
              </span>

              <span>
                nexisfold@gmail.com
              </span>

            </a>


            <a
              href="tel:+91 9022590056"
              className="nf-footer-contact-item"
            >

              <span className="nf-contact-icon">
                <Phone size={18} />
              </span>

              <span>
                +91 90225 90056
              </span>

            </a>

            <a
              href="tel:+91 7249022008"
              className="nf-footer-contact-item"
            >

              <span className="nf-contact-icon">
                <Phone size={18} />
              </span>

              <span>
                +91 72490 22008
              </span>

            </a>



            <div className="nf-footer-contact-item">

              <span className="nf-contact-icon">
                <MapPin size={18} />
              </span>

              <span>
                Pune, India
              </span>

            </div>


            <div className="nf-footer-contact-item">

              <span className="nf-contact-icon">
                <Globe size={18} />
              </span>

              <span>
                Digital Product Development
              </span>

            </div>

          </div>

        </div>

      </div>



      {/* =====================================================
          FOOTER MIDDLE BAR
      ====================================================== */}

      <div className="nf-footer-middle">

        <div className="nf-footer-middle-container">


          <div className="nf-footer-middle-text">

            <span className="nf-footer-line"></span>

            LET'S BUILD SOMETHING GREAT

          </div>


          <Link
            to="/contact"
            className="nf-footer-contact-button"
          >

            Start a Project

            <ArrowUpRight size={17} />

          </Link>

        </div>

      </div>



      {/* =====================================================
          FOOTER BOTTOM
      ====================================================== */}

      <div className="nf-footer-bottom">

        <div className="nf-footer-bottom-container">


          <div className="nf-footer-copyright">

            © {currentYear} Nexis Fold.

            <span>
              All rights reserved.
            </span>

          </div>


          {/* Social links are intentionally omitted until real profile URLs are configured. */}


          <div className="nf-footer-tagline">

            BUILDING THE DIGITAL FUTURE

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;